import { render } from "./view.vue?vue&type=template&id=1f827622&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"

import "./view.vue?vue&type=style&index=0&id=1f827622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f827622"]])

export default __exports__